@if (!loadingService.isLoading) {
  <div class="consultation-request">
    @if (errorMessage) {
      <div class="container consultation-request-container">
        <div class="columns is-centered mx-0">
          <div class="column is-10">
            <div class="my-4">
              <app-error-notification classes="is-fullwidth notification-error p-3 has-text-black mb-5">
                <p class="is-inline" [innerHTML]="errorMessage"></p>
              </app-error-notification>
            </div>
          </div>
        </div>
      </div>
    } @else {
      <app-consultation-request-header></app-consultation-request-header>
      <div class="container consultation-request-container mt-2">
        <div class="columns is-centered mx-0">
          <div class="column is-10 pt-0" id="consultation-request-container">
            <div class="my-4">
              <app-consultation-request-patient-info
                [patientInfoForm]="patientInfoForm"
              ></app-consultation-request-patient-info>
            </div>
            <div class="my-4">
              <app-card
                title="Medical Questionnaire"
                headerClasses="p-4 has-text-weight-bold is-size-4-mobile card-header-title"
                contentClasses="p-4"
              >
                @if (medicalQuestionIds.length) {
                  <app-dynamic-questionnaire-form
                    data-qa-id="Medical Questions Form"
                    #medicalQuestionsForm
                    [storageKey]="consultationRequestTreatmentType"
                    [indexedDbName]="indexedDbName"
                    [questionIds]="medicalQuestionIds"
                    [externalData]="externalData"
                    (formReady)="onMedicalQuestionnaireFormReady($event)"
                  ></app-dynamic-questionnaire-form>
                }

                @if (showChooseALab) {
                  <div class="my-4">
                    <div class="info-section mb-5 p-4">
                      A lab test is required before a physician can prescribe treatment. This panel measures your
                      testosterone levels and key health markers to ensure treatment is safe and appropriate. We cover
                      the cost to help you get started faster.
                      <ul class="pt-4 pl-4">
                        <li>Includes: Total Testosterone, LH, Hemoglobin & Hematocrit, ALT, AST</li>
                        <li>No payment required at the lab</li>
                        <li>No appointment needed & most visits take about 10 minutes</li>
                        <li>Results are typically available within 24-48 hours</li>
                      </ul>
                    </div>
                    <app-test-center
                      [inHomeCollection]="inHomeCollectionAllowed"
                      [showHeader]="false"
                      [showSelectedCenter]="true"
                      noSelectedCenterLabel="Please select a lab location below."
                    ></app-test-center>
                    <hr />
                  </div>
                }

                <app-medical-history-questions
                  #medicalHistoryQuestionsForm
                  [allergiesDetailsInitialValue]="consultationRequest?.allergies"
                  [medicationDetailsInitialValue]="consultationRequest?.prescriptions"
                  [otherConditionsDetailsInitialValue]="consultationRequest?.health_info"
                ></app-medical-history-questions>
                <app-consultation-request-address
                  [title]="consultationRequestAddressTitle"
                  [addressForm]="addressForm"
                ></app-consultation-request-address>
                @if (upsellIds.length) {
                  <app-dynamic-questionnaire-form
                    class="upsell-questions"
                    data-qa-id="Upsell Questions Form"
                    #upsellQuestionsForm
                    [storageKey]="QuestionnaireStorageKeys.Upsells"
                    [questionIds]="upsellIds"
                    [externalData]="externalData"
                    (showLabFinderModal)="presentLabFinderModal()"
                  ></app-dynamic-questionnaire-form>
                }
              </app-card>
            </div>

            @if (agreementQuestionIds?.length) {
              <div class="my-4">
                <app-card headerClasses="is-hidden" contentClasses="p-4 terms-background">
                  <app-dynamic-questionnaire-form
                    data-qa-id="Agreement Questions Form"
                    #agreementQuestionsForm
                    [storageKey]="QuestionnaireStorageKeys.AgreementQuestions"
                    [questionIds]="agreementQuestionIds"
                    [externalData]="externalData"
                  ></app-dynamic-questionnaire-form>
                </app-card>
              </div>
            }

            <div class="my-4">
              @if (shouldDisplayBottomError) {
                <p
                  data-qa-id="Questionnaire Continue Button Error"
                  class="has-text-centered has-text-weight-ultrabold mb-3 has-text-danger"
                >
                  {{ submissionError || responseError }}
                </p>
              }
              <button
                type="button"
                (click)="continue()"
                class="continue-button button is-rounded is-primary"
                data-qa-id="Questionnaire Continue Button"
                [disabled]="isProcessing || continueErrorMessage"
              >
                @if (isProcessing) {
                  <i class="fa fa-spin fa-spinner"></i>
                } @else {
                  <span>Continue</span>
                }
              </button>
              @if (continueErrorMessage) {
                <p data-qa-id="Continue Button Error Message" class="has-text-danger has-text-centered mt-3">
                  {{ continueErrorMessage }}
                </p>
              }
            </div>
          </div>
        </div>
      </div>
    }
  </div>
}

@if (showLabFinderModal) {
  <app-lab-finder-modal
    [(active)]="showLabFinderModal"
    data-qa-id="Lab Finder Modal"
    searchDescription="To find the nearest lab for your test, please enter your zip code below. These labs do not require an appointment."
  ></app-lab-finder-modal>
}
